export default __webpack_public_path__ + "static/g3one-e29b0fe8a35c96368c1e3d6b4018b262.jpg";